import type { FunctionComponent } from 'react';

import { Layout } from '@kanda-libs/ks-design-library';

import { CardPaymentForm, JobButton, MobileHeader } from 'components';

import { PayByCardPropsHook } from '../usePayByCardProps';

const Mobile: FunctionComponent<PayByCardPropsHook> = (props) => (
  <Layout header={<MobileHeader />} noBorder>
    <JobButton compact />
    <div className="mb-10" />
    <CardPaymentForm
      {...props}
      showMobileTitle
      title="Enter card details below"
      buttonLabel="Pay for job"
      showActionRequired={false}
    />
  </Layout>
);

export default Mobile;
